import PropTypes from 'prop-types'
import useMediaQuery from '@mui/material/useMediaQuery'

import { MOBILE_VIEWPORT } from '../../guided-toolbox/utils/breakpoints'
import DataTable, { columnPropTypes } from '../DataTable'
import IncludedBadge from './IncludedBadge'

// Owned here rather than declared by callers: its value comes from each row's
// `included` flag, not from `row.values`.
const INCLUDED_COLUMN = { key: 'included', label: 'Included?', align: 'right' }

/**
 * Adapts advice rows for the shared table: `included` becomes a final column on
 * desktop or a badge on mobile, and excluded rows are muted.
 */
const AdviceDataTable = ({ columns, rows, className }) => {
  const isMobile = useMediaQuery(MOBILE_VIEWPORT)

  const tableColumns = isMobile ? columns : [...columns, INCLUDED_COLUMN]

  const tableRows = rows.map(row => ({
    id: row.id,
    muted: !row.included,
    cardTitle: row.cardTitle,
    values: isMobile
      ? row.values
      : { ...row.values, [INCLUDED_COLUMN.key]: row.included ? 'Yes' : 'No' },
    trailing: isMobile ? <IncludedBadge included={row.included} /> : undefined,
  }))

  return <DataTable columns={tableColumns} rows={tableRows} className={className} />
}

AdviceDataTable.propTypes = {
  /** The screen's own columns; the Included? column is appended on desktop. */
  columns: PropTypes.arrayOf(PropTypes.shape(columnPropTypes)).isRequired,
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      /** Whether the row is included in the plan; drives the Included? display and the muting. */
      included: PropTypes.bool.isRequired,
      values: PropTypes.objectOf(PropTypes.node).isRequired,
      /** Overrides the mobile card title. */
      cardTitle: PropTypes.string,
    })
  ).isRequired,
  className: PropTypes.string,
}

export default AdviceDataTable
